import { gameState } from "appworks/model/game-state";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { PartnerConnectHistorySpinCommand } from "partner-connect/commands/partner-connect-history-spin-command";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import { PartnerConnectRequestSpin } from "./partner-connect-request-spin";

export class PartnerConnectHistorySpin extends PartnerConnectRequestSpin {

    protected startSpinning(): Contract<any> {
        if (PartnerConnectManager.isHistoryPending()) {
            return new Parallel([
                () => StartSpinCommand(),
                () => PartnerConnectHistorySpinCommand(),
                () => Contract.wrap(() => gameState.getCurrentGame().nextRecord())
            ]);
        } else {
            return PartnerConnectHistorySpinCommand();
        }
    }

    protected newGame() {
        if (!gameState.getCurrentGame().getCurrentRecord()) {
            gameState.autoDeductStake = false;
            super.newGame();
            gameState.autoDeductStake = true;
        }
    }
}
